import React, { useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';
import { StackHolder } from '../../../../component';
import { withRouter } from '~HOC';
import {
  BarsIcon,
  CloseIcon,
  DashboardIcon,
  LogoutIcon,
  BarcodeIcon,
  AirplaneIcon,
  InfoCircleIcon,
  CommentIcon,
  FeaturesIcon,
} from '~svg/index';
import { commonRoute, gamesRoute } from '../../../../utils/consts';
import '../mobileHeader/mobileHeader.scss';

const MobileProfileHeader = (props) => {
  let { basicInfo, firstName, lastName } = props?.userInfo?.user
    ? props.userInfo.user[0]
    : false;
  const [profiletype, setProfiletype] = useState();
  const [isOpenOption, setIsOpenOption] = useState(false);
  const [currentProfile, setCurrentProfile] = useState();
  const {
    urlLocation = window.location.origin,
    showInprofile,
    changeStateshow,
    direction,
    showMobileMenu,
    CloseMobileMenu,
    changeLanguage,
    isLogOut,
    profileRoutes,
    pathname,
    closeMenu,
    profileMenu,
    individualDashboarditems,
    businessDashboarditems,
    signOut,
    flightBookingRoutes,
    userInfo,
    loginLink,
    generalUser,
  } = props;

  const isTripord = String(urlLocation).includes('tripord');

  const profiles = {
    individualDashboarditems,
    businessDashboarditems,
  };

  return (
    <>
      {showInprofile && (
        <div className={`w-100 d-flex d-lg-none justify-content-between px-3`}>
          <div className="col px-0 text-primary-light d-flex flex-row align-items-center justify-content-start font-xxlarge">
            <div onClick={changeStateshow}>
              <BarsIcon size={36} color="#4c54b9" />
            </div>
          </div>
          <Link
            className={`d-flex align-items-center justify-content-center border-2 px-0 cursor-default col-6`}
            to={flightBookingRoutes.selectCity}
          >
            <img
              className={`p-0 font-small cursor-pointer ${
                isTripord && ' col-sm-6 col-9 px-0'
              }`}
              src={require(`../../../../content/images/icon/${
                isTripord ? 'tripord-logo.webp' : 'tripsi-logo.webp'
              }`)}
              width={130}
              height={isTripord ? '40px' : '55px'}
              alt={isTripord ? 'tripsi icon' : 'tripord icon'}
            />
          </Link>
          <div className="col px-0"></div>
          <div
            className={`w-100 font-large flex-column align-items-start position-fixed  h-100 bg-primary p-3 text-white`}
            style={{
              maxHeight: '100vh',
              overflow: 'auto',
              top: 0,
              right: direction === 'rtl' && (showMobileMenu ? '0' : '-100%'),
              left: direction === 'ltr' && (showMobileMenu ? '0' : '-100%'),
              transition: 'all 0.8s',
              transitionTimingFunction: 'ease',
              zIndex: 2000,
              overscrollBehavior: 'contain',
            }}
          >
            <div className="d-flex font-xxlarge justify-content-between w-100 align-items-center">
              <div onClick={CloseMobileMenu}>
                <CloseIcon size={24} color="white" />
              </div>
              {changeLanguage}
            </div>
            <div className="w-100 d-flex align-items-start  justify-content-center flex-column p-3 text-nowrap font-normal">
              <div
                className="d-flex flex-column align-items-center"
                style={{ gap: '2rem' }}
              >
                <div className="d-flex align-itesm-center position-relative ">
                  <div
                    className="rounded-circle"
                    style={{
                      backgroundImage:
                        'conic-gradient(transparent, var(--secondary-light))',
                    }}
                  >
                    <img
                      className="  rounded-circle bg-primary p-1 "
                      style={{ width: '4rem', margin: '0.15rem' }}
                      src={require(`../../../../content/images/avatars/${
                        basicInfo ? basicInfo.avatar : '23.png'
                      }`)}
                      alt={'avatars'}
                    />
                  </div>
                  <div className="px-2 d-flex  flex-column  align-items-start  justify-content-center ">
                    <div className="d-flex align-items-center">
                      {!basicInfo && (
                        <FormattedMessage id="booking.guestuser" />
                      )}
                      <div>{basicInfo && firstName}</div>
                      <div className="px-2">{basicInfo && lastName}</div>
                    </div>
                    <div className="pt-2">
                      {/* {!basicInfo && props.loginLink} */}
                      <StackHolder
                        onChange={(profileType, profileData) => {
                          setProfiletype(profileType);
                          setCurrentProfile(profileData);
                          let index = profiles?.[profileType]?.findIndex(
                            (item) =>
                              props.location.pathname.includes(item.link),
                          );
                          if (index < 0 && profileData) {
                            props.navigate(profileData.profileRoute);
                          } else {
                            props.navigate(props.location.pathname);
                          }
                        }}
                        CloseMobileMenu={CloseMobileMenu}
                      />
                    </div>
                    {basicInfo && profileMenu}
                  </div>
                </div>
                {!isLogOut && (
                  <div className=" d-flex align-items-center w-100">
                    <div
                      className={`text-start text-secondary-light col-2 px-1`}
                    >
                      <DashboardIcon size={22} color="#80c494" />
                    </div>
                    <Link
                      className=""
                      to={profileRoutes.dashboard}
                      onClick={closeMenu}
                    >
                      <div
                        className={`${
                          pathname === profileRoutes.dashboard
                            ? 'text-white'
                            : 'text-third'
                        } font-weight-bold `}
                      >
                        <FormattedMessage id={`${'header.manage'}`} />
                      </div>
                    </Link>
                  </div>
                )}
                {profiletype === 'individual'
                  ? individualDashboarditems.map((item, index) => {
                      return (
                        <React.Fragment key={`mobile-menu-indivisual-${index}`}>
                          <div className="text-start d-flex align-items-center w-100">
                            <div
                              className={`text-start text-secondary-light col-2 px-0`}
                            >
                              {item.icon}
                            </div>
                            <Link
                              className=""
                              to={item.link}
                              onClick={closeMenu}
                            >
                              <div
                                className={`${
                                  pathname === item.link.split('?')[0]
                                    ? 'text-white'
                                    : 'text-third'
                                } font-weight-bold`}
                              >
                                <FormattedMessage id={item.label} />
                              </div>
                            </Link>
                          </div>
                        </React.Fragment>
                      );
                    })
                  : businessDashboarditems.map((item, index) => {
                      return (
                        <React.Fragment key={`mobile-menu-business-${index}`}>
                          <div className="text-start d-flex align-items-center w-100">
                            <div
                              className={`text-start text-secondary-light col-2 px-0`}
                            >
                              {item.icon}
                            </div>

                            <Link to={item.link} onClick={closeMenu}>
                              <div
                                className={`${
                                  pathname === item.link.split('?')[0]
                                    ? 'text-white'
                                    : 'text-third'
                                } font-weight-bold`}
                              >
                                <FormattedMessage id={item.label} />
                              </div>
                            </Link>
                          </div>
                        </React.Fragment>
                      );
                    })}
                {!isLogOut && (
                  <div className="text-start d-flex align-items-center w-100 cursor-pointer">
                    <div className="text-secondary-light col-2 px-1">
                      <LogoutIcon size={22} color="#80c494" />
                    </div>
                    <div
                      className="text-third font-weight-bold"
                      onClick={signOut}
                    >
                      <FormattedMessage id="profile.signout" />
                    </div>
                  </div>
                )}
                <div
                  className="w-100 d-flex flex-column justify-content-start align-items-start border-top border-secondary-light pt-4"
                  style={{ gap: '2rem' }}
                  onClick={() => {
                    CloseMobileMenu();
                  }}
                >
                  <div className="d-flex align-items-center w-100 mt-2">
                    <div
                      className={`text-start text-secondary-light col-2 px-1`}
                    >
                      <AirplaneIcon size={22} color="#80c494" />
                    </div>

                    <Link
                      to={flightBookingRoutes.selectCity}
                      onClick={closeMenu}
                      className="text-primary-dark"
                    >
                      <div className="text-third font-weight-bold">
                        <FormattedMessage id="header.book" />
                      </div>
                    </Link>
                  </div>
                  {isLogOut && (
                    <div className=" d-flex align-items-center w-100">
                      <div
                        className={`text-start text-secondary-light col-2 px-1`}
                      >
                        <BarcodeIcon size={22} color="#80c494" />
                      </div>
                      <Link
                        to={flightBookingRoutes.trackingOrder}
                        onClick={closeMenu}
                      >
                        <div className="text-third font-weight-bold">
                          <FormattedMessage id="booking.trackorder" />
                        </div>
                      </Link>
                    </div>
                  )}
                  <div
                    className="d-flex flex-column align-items-start w-100"
                    onClick={(e) => {
                      e.stopPropagation();
                      setIsOpenOption(!isOpenOption);
                    }}
                  >
                    <div className="d-flex flex-row text-third font-weight-bold">
                      <div
                        className={`text-start text-secondary-light col px-1`}
                      >
                        <FeaturesIcon size={22} color="#80c494" />
                      </div>
                      <span className="d-flex align-items-center px-2 cursor-pointer">
                        <FormattedMessage id="otheroption.otheroptions" />
                      </span>
                    </div>

                    {isOpenOption && (
                      <>
                        <div
                          className={`w-100 px-4 pt-2 show-option-animation`}
                        >
                          <Link
                            className="d-flex align-items-center w-100 pt-3"
                            to={commonRoute.otherOption}
                            onClick={() => {
                              CloseMobileMenu();
                            }}
                          >
                            <div className="text-third font-weight-bold">
                              - <FormattedMessage id="profile.calendar" />
                            </div>
                          </Link>
                          <Link
                            style={{
                              opacity: 0.5,
                              cursor: 'not-allowed',
                            }}
                            className="d-flex align-items-center w-100 pt-3"
                            onClick={() => {
                              CloseMobileMenu();
                            }}
                          >
                            <div className="text-third diasable">
                              -{' '}
                              <FormattedMessage
                                id={`${
                                  pathname.includes('tripord')
                                    ? 'header.smarttripord'
                                    : 'header.smarttripsi'
                                }`}
                              />
                            </div>
                          </Link>
                          <Link
                            style={{
                              opacity: 0.5,
                              cursor: 'not-allowed',
                            }}
                            className="d-flex align-items-center w-100 pt-3"
                            to={gamesRoute.backgammon}
                            onClick={() => {
                              CloseMobileMenu();
                            }}
                          >
                            <div className="text-third">
                              - <FormattedMessage id={'profile.game'} />
                            </div>
                          </Link>
                        </div>
                      </>
                    )}
                  </div>
                  <div className="d-flex align-items-center w-100">
                    <div
                      className={`text-start text-secondary-light col-2 px-1`}
                    >
                      <InfoCircleIcon size={22} color="#80c494" />
                    </div>
                    <Link className="text-third" to={'/about'}>
                      <FormattedMessage
                        id={`${
                          pathname.includes('tripord')
                            ? 'aboutus.tripord'
                            : 'aboutus.tripsi'
                        }`}
                      />
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {!userInfo?.user?.length ? loginLink : generalUser}
        </div>
      )}
    </>
  );
};

export default withRouter(MobileProfileHeader);
